export default __webpack_public_path__ + "1fcbc2ea422cb4e7e2a22e2918999344.svg";